import React from 'react'
import "./historyItemPart.css"
export const HistoryItemPart = ({onClose}) => {
    return (
        <section className='HistoryItemPart'>
            <header className='HistoryItemPart-header'>
                <i className='icon-stock'></i>
                <h3>Change Log</h3>
                <p>
                    PN
                    <span>
                        111-222-333
                    </span>
                </p>
                <button onClick={onClose}>
                    <i className='icon-cross'></i>
                </button>
            </header>
            <main className='HistoryItemPart-main'>
                <div>
                    <span></span>
                    <p style={{
                        flexGrow: "1"
                    }}>Updated Requested Parts Quantity from 12 to<span>10 Units</span></p>
                    <p >Modified By: John Smith</p>
                    <p style={{
                        color: "#858585"
                    }}>2025/03/11, 15:22</p>
                </div>
                <div>
                    <span></span>
                    <p style={{
                        flexGrow: "1"
                    }}>Updated Status to<span>Partially Dispatched</span></p>
                    <p >Modified By: John Smith</p>
                    <p style={{
                        color: "#858585"
                    }}>2025/03/11, 15:22</p>
                </div>
                <div>
                    <span></span>
                    <p style={{
                        flexGrow: "1"
                    }}>Updated Requested Parts Quantity from 7 to<span>12 Units</span></p>
                    <p >Modified By: John Smith</p>
                    <p style={{
                        color: "#858585"
                    }}>2025/03/11, 15:22</p>
                </div>
                <div>
                    <span></span>
                    <p style={{
                        flexGrow: "1"
                    }}>Assigned<span>New Batch 168</span></p>
                    <p >Modified By: John Smith</p>
                    <p style={{
                        color: "#858585"
                    }}>2025/03/11, 15:22</p>
                </div>
                <div>
                    <span></span>
                    <p style={{
                        flexGrow: "1"
                    }}>Requested Parts Quantity<span>7 Units</span></p>
                    <p >Modified By: John Smith</p>
                    <p style={{
                        color: "#858585"
                    }}>2025/03/11, 15:22</p>
                </div>
            </main>
        </section>
    )
}
